
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/_mp/pools",
      function () {
        return require("private-next-pages/_mp/pools/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/_mp/pools"])
      });
    }
  